import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'; // Opcional, caso tenha estilos globais
import App from './App';
import { DebugProvider } from './components/ferramentas/DebugConsole';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DebugProvider>
      <App />
    </DebugProvider>
  </React.StrictMode>
);
